import * as React from 'react';
import { fetchCountry } from '@gandi/redux-places';
import { useTranslator } from '@gandi/translate';
import { InputTextField } from 'gandi.react-form';
import useCountry from '../hooks/useCountry';
import { jsx as _jsx } from "react/jsx-runtime";
function PhoneField({
  country,
  bu,
  ...inputProps
}) {
  const {
    __
  } = useTranslator();
  const {
    phonePrefix
  } = useCountry(country, bu);
  return /*#__PURE__*/_jsx(InputTextField, {
    label: __('Phone'),
    name: "phone",
    placeholder: phonePrefix,
    ...inputProps
  });
}
PhoneField.preFetch = function preFetch({
  country,
  bu,
  dispatch
}) {
  if (country) {
    return dispatch(fetchCountry(country, bu));
  }
  return Promise.resolve();
};
export default PhoneField;